export const structure = {
label: 'ESTRUCTURA',
title: 'Liderazgo Definido.',
subtitle: 'Una estructura corporativa directa diseñada para apoyar la responsabilidad, operaciones eficientes y desarrollo empresarial a largo plazo.',

entity_1_label: 'ENTIDAD CORPORATIVA',
entity_1_name: 'One More Global Inc.',
entity_1_role: 'Corporación Estadounidense',
entity_1_location: 'Houston, Texas, EE.UU.',
entity_1_desc: 'Responsable de sus operaciones comerciales, distribución de productos, desarrollo de mercado, alianzas estratégicas y crecimiento organizacional.',

hierarchy_title: 'Jerarquía Organizacional',
hierarchy_level_1: 'Director Ejecutivo (CEO)',
hierarchy_level_1_desc: 'Alper Volkan Karpuz proporciona la dirección estratégica general y el liderazgo ejecutivo.',
hierarchy_level_2: 'Liderazgo Ejecutivo y Operativo',
hierarchy_level_2_desc: 'Líderes senior que gestionan tecnología, operaciones, expansión y funciones administrativas.',

leadership_title: 'Liderazgo Corporativo',
diagram_title: 'Estructura de Liderazgo',
entity_table_title: 'Resumen de la Empresa',
};
